// Os rótulos e os TONS da Central do Perito, portados de `src/lib/format.ts` (03/11, 000385). As datas
// saíram daqui para `datas.ts`, porque as de lá liam o dia em UTC (ver o cabeçalho de lá). O tom é o ESTADO,
// e não a classe: quem pinta é o `Chip` de `componentes/PeritoUi.tsx`, com um mapa tom → token só.
import type { NivelAlerta, Prioridade, StatusPagamento, StatusPericia, StatusTarefa } from "./tipos";

export function formatBRL(v: number): string {
  return v.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

export type Tom = "neutro" | "ok" | "atencao" | "erro" | "info";

export const STATUS_PERICIA_LABEL: Record<StatusPericia, string> = {
  andamento: "Em andamento",
  atencao: "Atenção",
  vencido: "Vencido",
  finalizado: "Finalizada",
  arquivado: "Arquivado",
};

export const STATUS_PERICIA_TOM: Record<StatusPericia, Tom> = {
  andamento: "info",
  atencao: "atencao",
  vencido: "erro",
  finalizado: "ok",
  arquivado: "neutro",
};

export const PRIORIDADE_LABEL: Record<Prioridade, string> = { baixa: "Baixa", media: "Média", alta: "Alta", urgente: "Urgente" };

export const PRIORIDADE_TOM: Record<Prioridade, Tom> = { baixa: "neutro", media: "info", alta: "atencao", urgente: "erro" };

export const ALERTA_TOM: Record<NivelAlerta, Tom> = { critico: "erro", atencao: "atencao", info: "info", sucesso: "ok" };

export const PAGAMENTO_LABEL: Record<StatusPagamento, string> = { pendente: "Pendente", parcial: "Parcial", pago: "Pago" };

// "Pendente" é atenção, e não erro: honorário que ainda não venceu não é problema. O vermelho fica para o que
// passou do prazo.
export const PAGAMENTO_TOM: Record<StatusPagamento, Tom> = { pendente: "atencao", parcial: "info", pago: "ok" };

export const TAREFA_LABEL: Record<StatusTarefa, string> = { pendente: "Pendente", andamento: "Em andamento", concluida: "Concluída" };

export const TAREFA_TOM: Record<StatusTarefa, Tom> = { pendente: "atencao", andamento: "info", concluida: "ok" };

export const PARTE_LABEL = { autor: "Autor", reu: "Réu", advogado: "Advogado", terceiro: "Terceiro" } as const;

/** Singular ou plural, com o número: "1 perícia", "3 perícias". */
export function plural(n: number, um: string, varios: string): string {
  return `${n.toLocaleString("pt-BR")} ${n === 1 ? um : varios}`;
}
